<template>
  <ParallelEditErrorModal></ParallelEditErrorModal>
  <div class="home relative h-full">
    <OrderOverview
      v-if="store?.state?.OrderStore?.orders.length"
      :orders="(store?.state?.OrderStore?.orders as Order[])"
      @refreshData="refreshData"
    ></OrderOverview>
    <div class="absolute z-1 inset-0 flex items-center justify-center" v-else>
      <div
        id="order-button"
        class="fixed z-19 bottom-[80px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      >
        <db-button
          @click="$router.push('/orders/create')"
          class="hydrated"
          variant="brand-primary"
        >
          {{ $t("order.add") }}
        </db-button>
      </div>
      <span class="text-gray-500 w-40">{{ $t("order.empty") }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import OrderOverview from "@/components/orders/OrderOverview.vue";
import firebaseAuthService from "@/services/FirebaseAuthService";
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { reAuthorize } from "@/services/auth/re-auth";
import ParallelEditErrorModal from "@/components/ParallelEditErrorModal.vue";
import { Order } from "@/data/interfaces/OrderInterface";
import { DbButton } from "@db-ui/v-elements-enterprise/dist/components";

export default defineComponent({
  name: "HomeView",
  setup() {
    const store = useStore();

    const startFetchingOrders = () => {
      // Fetch orders immediately when the component loads
      store.dispatch("OrderStore/getOrders");

      // Fetch orders every 60 seconds using setInterval
      const intervalId = setInterval(() => {
        store.dispatch("OrderStore/getOrders");
      }, 60000); // 60 seconds in milliseconds

      return intervalId;
    };

    let fetchOrdersInterval = 0 as number;

    onMounted(() => {
      // Start fetching orders when the component is mounted
      reAuthorize(store).then((res) => {
        fetchOrdersInterval = startFetchingOrders();
        store.dispatch("OrderStore/getTerminals");
      });
    });

    onBeforeUnmount(() => {
      // Stop fetching orders when the component is unmounted
      clearInterval(fetchOrdersInterval);
    });

    const router = useRouter();
    const logout = async () => {
      await firebaseAuthService.logout();
      router.push("/login");
    };

    const refreshData = () => {
      store.dispatch("OrderStore/getOrders");
    };

    return {
      logout,
      store,
      refreshData,
    };
  },
  components: {
    OrderOverview,
    ParallelEditErrorModal,
    DbButton,
  },
});
</script>
